<template>
    <el-popover
            placement="bottom"
            :visible-arrow="false"
            :width="dropDownWidth"
            trigger="manual"
            v-model="visible">
        <ul ref="ul" class="drop-down" :style="{maxHeight:this.dropDownMaxHeight+'px'}">
            <li ref="li" class="drop-down-item" v-for="(item, index) in list" :key="index" @click="select(item)"
                :class="index===selected?'selected':''" @mouseenter="selected=index">{{getItemValue(item)}}</li>
            <infinite-loading :distance="50" spinner="waveDots" :identifier="infiniteId" @infinite="infiniteHandler">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
                <div slot="error">加载出错</div>
            </infinite-loading>
        </ul>
        <el-input ref="input" :value="value||''" @input="input" :placeholder="placeholder" @focus="focus" slot="reference"
                  @keydown.down.native.prevent="onPageDown" @keydown.up.native.prevent="onPageUp"
                  @keydown.enter.native="onEnter" @keydown.native.tab="hideDropDown" @blur="hideDropDown"></el-input>
    </el-popover>
</template>

<script>
import {debounce} from '../../service/FunctionUtils'
import InfiniteLoading from 'vue-infinite-loading'

export default {
    name: 'autocomplete',
    components: {InfiniteLoading},
    props: {
        value:{
            type: String
        },
        placeholder:{
            type: String
        },
        fetchSuggestions: {
            type: Function,
            required: true
        },
        dropDownMaxHeight: {
            type: Number,
            default: 280
        },
        valueKey:{
            type: String,
            default: 'value'
        }
    },
    data() {
        return {
            visible: false,
            list: [],
            total: 0,
            page: 0,
            debouncedSearch: debounce(this.search,500),
            dropDownWidth: 150,
            infiniteId: 1,
            keyword: null,
            selected: null,
            lastScrollTop: 0,
        }
    },
    computed: {
        nativeInputValue() {
            return this.value === null || this.value === undefined ? '' : this.value;
        },
    },
    methods: {
        input(newValue) {
            if(newValue === this.nativeInputValue){
                return
            }
            this.$emit('input', newValue)
            this.debouncedSearch(newValue)
        },
        search(keyword){
            this.keyword = keyword
            this.list = []
            this.totalPages = 0
            this.page = 0
            this.infiniteId = this.infiniteId+1
            this.dropDownWidth = this.$refs.input.$el.offsetWidth-24
            this.selected=null
            this.lastScrollTop=0
            this.showDropDown()
        },
        select(item){
            const value = this.getItemValue(item)
            this.$emit('input', value)
            this.$emit('select', item)
            this.hideDropDown()
        },
        getItemValue(item){
            if(typeof item === 'string') {
                return item
            }else{
                return item[this.valueKey]
            }
        },
        focus(){
            if(this.list.length>0){
                this.showDropDown()
            }
        },
        infiniteHandler($state){
            const currentInfiniteId = this.infiniteId
            this.fetchSuggestions(this.keyword, this.page+1, result => {
                if (this.infiniteId!==currentInfiniteId){
                    return
                }
                this.list.push(...result.rows)
                this.totalPages=result.totalPages
                this.page=result.page
                if(result.page>=result.totalPages){
                    $state.complete()
                }else{
                    $state.loaded()
                }
            })
        },
        scrollDown(){
            const ulEl=this.$refs.ul
            if(this.selected<this.list.length-1){
                // 如果下一个选项离视口底部不到5px，则滚动到5px位置
                const liEl=this.$refs.li[this.selected+1]
                const ulBottom=ulEl.offsetTop+ulEl.offsetHeight
                const liBottom=liEl.offsetTop+liEl.offsetHeight-ulEl.scrollTop
                const dis=ulBottom-liBottom
                if(dis<5){
                    ulEl.scrollTop = ulEl.scrollTop+5-dis
                }
            }else if(this.page<this.totalPages){
                // 如果没有下一个选项，且有下一页数据，则滚动到底部
                ulEl.scrollTop=ulEl.scrollHeight
            }

        },
        onPageDown(event){
            event.preventDefault()
            event.stopPropagation()
            if(this.list.length>0){
                if(!this.visible){
                    this.showDropDown()
                    return
                }else if(this.selected===null){
                    this.selected=0
                }else if(this.selected<this.list.length-1){
                    this.selected++
                }else{
                    return
                }
                this.scrollDown()
            }
        },
        scrollUp(){
            // 如果上一个选项离视口顶部不到5px，则滚动到5px位置
            const ulEl=this.$refs.ul
            const liEl=this.$refs.li[this.selected>0?this.selected-1:this.selected]
            const dis=liEl.offsetTop-ulEl.scrollTop-ulEl.offsetTop
            if(dis<5){
                ulEl.scrollTop = ulEl.scrollTop-(5-dis)
            }
        },
        onPageUp(event){
            event.preventDefault()
            event.stopPropagation()
            if(this.list.length>0){
                if(!this.visible){
                    this.showDropDown()
                    return
                }else if(this.selected>0){
                    this.selected--
                    this.scrollUp()
                }else{
                    return
                }
            }
        },
        hideDropDown(){
            if(this.visible){
                this.lastScrollTop=this.$refs.ul.scrollTop
                this.visible=false
            }
        },
        showDropDown(){
            if(!this.visible){
                this.visible=true
                this.$nextTick(()=>{
                    this.$refs.ul.scrollTop=this.lastScrollTop
                })
            }
        },
        onEnter(){
            if(this.selected!==null){
                this.select(this.list[this.selected])
            }
        }
    }
}
</script>
<style scoped>
.drop-down{
    margin: 0 -12px;
    overflow: auto;
    list-style: none;
    padding: 0;
}
.drop-down-item{
    font-size: 14px;
    line-height: 34px;
    text-overflow: ellipsis;
    padding: 0 10px;
    cursor: pointer;
}
.drop-down-item.selected{
    background-color: #f5f7fa;
}
</style>
